import {getLFCData} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import {useSnackbar} from 'notistack';
import {createContext, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {useMySettings} from './MySettingsProvider';

export const MenuTabContext = createContext({
  menuData: [],
  tabData: [],
  reLoad: () => console.error('false')
});

export const MenuTabProvider = (props: any) => {
  const {children} = props;
  const {enqueueSnackbar} = useSnackbar();
  const mySettings = useMySettings();
  const [menuData, setMenuData] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [menuDataOutput, setMenuDataOutput] = useState([]);
  const [tabDataOutput, setTabDataOutput] = useState([]);
  const [menuTabContext, setMenuTabContext] = useState({
    menuData: menuData,
    tabData: tabData,
    reLoad: () => console.error('false')
  });
  const {t} = useTranslation();
  const cancelSource = useRef<CancelTokenSource | null>(null);

  const loadApiFetch = async () => {
    if (cancelSource.current) cancelSource.current.cancel('req cancel');

    cancelSource.current = axios.CancelToken.source();
    await getLFCData({
      snack: enqueueSnackbar,
      sql_id: 90001,
      parameters: {},
      ds_state: setMenuData,
      name: 'メニュー取得',
      cancelToken: cancelSource.current.token,
      t
    });
    await getLFCData({
      snack: enqueueSnackbar,
      sql_id: 90002,
      parameters: {},
      ds_state: setTabData,
      name: 'メニュータブ取得',
      cancelToken: cancelSource.current.token,
      t
    });
  };

  useEffect(() => {
    return () => {
      // アンマウント処理
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  /**
   * 認証情報変更時の処理
   */
  useEffect(() => {
    if (0 === Object.keys(mySettings).length) {
      //未認証だったら初期化
      setMenuData([]);
      setTabData([]);
      return;
    }
    loadApiFetch();
  }, [mySettings]);

  useEffect(() => {
    const myMenu_exist: any = menuData.find((datas: any) => datas.tab_name === 'マイメニュー');
    if (myMenu_exist === undefined) {
      tabData.splice(0, 1);
    }
    setMenuDataOutput(menuData);
    setTabDataOutput(tabData);
  }, [menuData, tabData]);

  useEffect(() => {
    setMenuTabContext({menuData: menuDataOutput, tabData: tabDataOutput, reLoad: loadApiFetch});
  }, [menuDataOutput, tabDataOutput]);

  return (
    <div>
      <MenuTabContext.Provider value={menuTabContext}>{children}</MenuTabContext.Provider>
    </div>
  );
};

export default MenuTabProvider;
